import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class SimuladorFreteService {
  constructor(private readonly http: HttpClient) {}

  public async get(cep: number, data: any): Promise<any> {
    try {
      const url = `${environment.angularJSconstants.URLAPI}/v3/postalcodes/${cep}/rates`;

      // O interceptor irá automaticamente usar o token de API para URLs que contenham "/rates"
      return await this.http
        .post(url, { items: data, freightRuleDetails: true })
        .toPromise();
    } catch (error) {
      console.error('Erro ao calcular frete:', error);
      throw error;
    }
  }

  public async getToken(): Promise<any> {
    try {
      const url = `${environment.angularJSconstants.URLAPICLIENTE}/api`;

      return await this.http.get(url).toPromise();
    } catch (error) {
      console.error('Erro ao obter token:', error);
      throw error;
    }
  }
}
